/** UserTestCasePresenceStatus
 * generated by enums.tst
**/
var UserTestCasePresenceStatus;
(function (UserTestCasePresenceStatus) {
    UserTestCasePresenceStatus[UserTestCasePresenceStatus["Included"] = 0] = "Included";
    UserTestCasePresenceStatus[UserTestCasePresenceStatus["Manual"] = 1] = "Manual";
    UserTestCasePresenceStatus[UserTestCasePresenceStatus["ICS"] = 2] = "ICS";
    UserTestCasePresenceStatus[UserTestCasePresenceStatus["Global"] = 3] = "Global";
    UserTestCasePresenceStatus[UserTestCasePresenceStatus["ICSWithOverride"] = 4] = "ICSWithOverride";
})(UserTestCasePresenceStatus || (UserTestCasePresenceStatus = {}));
